import { render, staticRenderFns } from "./InstagramMedia.vue?vue&type=template&id=a0e2c0a8&"
import script from "./InstagramMedia.vue?vue&type=script&lang=js&"
export * from "./InstagramMedia.vue?vue&type=script&lang=js&"
import style0 from "./InstagramMedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports